import type { AvailableLayer } from '~/api/availableLayers';

/** A catalog group is "in the library" iff any of its sub-layers is present in the membership set. */
export function computeLibraryLayerIds(catalog: Map<string, AvailableLayer>, nodeIds: Iterable<string>): Set<string> {
  const present = new Set(nodeIds);
  const result = new Set<string>();
  for (const layer of catalog.values()) {
    if (layer.subLayers.some((subLayer) => present.has(subLayer.key))) result.add(layer.key);
  }
  return result;
}
